import {
  Component,
  EventEmitter,
  inject,
  Injector,
  Input,
  input,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { Widget } from '../models/dashboard';
import { NgComponentOutlet } from '@angular/common';
import { WidgetOptionsComponent } from './widget-options/widget-options.component';
import { WidgetHeaderComponent } from './widget-header/widget-header.component';
import { DragDropModule } from 'primeng/dragdrop';
import { ResizableModule, ResizeEvent } from 'angular-resizable-element';
import { DashboardService } from '../services/dashboard.service';
import { CardModule } from 'primeng/card';
@Component({
  selector: 'app-widget',
  standalone: true,
  imports: [
    NgComponentOutlet,
    WidgetOptionsComponent,
    WidgetHeaderComponent,
    DragDropModule,
    ResizableModule,
    CardModule
  ],
  templateUrl: './widget.component.html',
  styleUrl: './widget.component.css',
})
export class WidgetComponent implements OnInit {
  @Output() resizeEnd = new EventEmitter<ResizeEvent>();
  /** Abstand in px für horizontales Snap (Spaltenbreite + gap) */
  @Input() snapX!: number;
  /** Abstand in px für vertikales Snap (Zeilenhöhe + gap) */
  @Input() snapY!: number;
  data = input.required<Widget>();
  isEditable = input.required<boolean>();

  showOptions = signal(false);

  dashboardService = inject(DashboardService);
  dataInjector!: Injector;

  constructor(private injector: Injector) {}

  ngOnInit() {
    this.dataInjector = Injector.create({
      providers: [
        { provide: 'contentData', useValue: this.data()?.contentData ?? '' },
        { provide: 'label', useValue: this.data()?.label ?? '' },
      ],
      parent: this.injector,
    });
  }

  onResizeEnd(event: ResizeEvent) {
    this.resizeEnd.emit(event);
  }
}
